import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {HistoryRouter} from 'redux-first-history/rr6';
import {HelmetProvider} from 'react-helmet-async';
import {Provider} from 'react-redux';
import App from './App';
import ScrollToTop from './ScrollToTop';


export default class Root extends Component {
  render() {
    const {store, history} = this.props;
    return (
      <HelmetProvider>
        <Provider store={store}>
          <HistoryRouter history={history}>
            <ScrollToTop>
              <App/>
            </ScrollToTop>
          </HistoryRouter>
        </Provider>
      </HelmetProvider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};
